<template>
  <div class="content">
    <div class="image-gallery">
      <Card v-for="image in product?.images" :key="image.fileId">
        <template #image>
          <img :src="`${config.public.apiUrl}/storage/products/thumbs/${image.fileId}.webp`" :alt="product.title">
        </template>
      </Card>

      <div class="product-info">
        <h1>{{ product?.title }}</h1>
        <p>{{ product?.description }}</p>

        <div v-if="product?.locations?.length" class="locations">
          <h3>Locatie</h3>
          <div v-for="location in product.locations" :key="location.id">
            {{ location.title }}
          </div>
        </div>

        <!-- <div v-if="product?.categories?.length" class="categories">
          <h3>Categorieën</h3>
          <Button
            v-for="category in product.categories"
            :key="category.id"
            type="button"
            with-border
            disabled>
            {{ category.title }}
          </Button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const route = useRoute()
const { data: product } = await useApi(`products/${route.params.id}`)

</script>

<style module>
.fieldset {
  border: 1px solid var(--border-subtle);
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  padding: var(--spacing-xl);
}

legend {
  padding: var(--spacing);
}

.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: var(--spacing-xl);
}

.product-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}
</style>
